export default {
  local: {
    'zh-CN': '简体中文',
    'en-US': '英语(美国)',
  },
  common: {
    404: '我是404消息',
    sn: '序号',
    slogan: '网站口号',
    guide: '产品指南',
    wel: '欢迎进入 ACS 系统 ',
    pageTitle: {
      costCenter: '成本中心管理',
      personCostCenter: '人员成本中心',
      matchRelation: '匹配关系配置',
      proLin: '产品线管理',
      checkProLin: '查看产品线',
      virtualTeame: '虚拟组织维护',
      virtualTeameConfig: '虚拟组织配置',
      checkTeame: '查看团队详情',
      syncManagement: '同步管理',
      menuManagement: '菜单管理',
      userManagement: '用户管理',
      userManagementDetail: '用户详情',
      orgManagement: '组织管理',
      roleManagement: '角色管理',
      roleManagementEdit: '角色权限管理',
      dataDictionary: '数据字典',
      loginLog: '登录日志',
      operationLog: '操作日志',
      internationConfig: '国际化配置',
      materialInformation: '物料信息',
      accountManage: '账号管理',
      accountDetail: '账号详情',
      changeLog: '变更记录',
      roleManage: '角色管理',
      roleDetail: '角色详情',
      myPermission: '我的权限',
      personalPermission: '人员权限',
      ppManage: '权限点管理',
      subordinate: '下属权限',
      permissionUsers: '授权用户',
      apply: '权限申请',
      taskDetail: '任务详情',
      checkReport: '人员审查报告',
      groupReport: '公司审查报告',
      reportDetail: '审查报告详情',
      logRolePoint: '角色权限日志',
      logPerson: '人员日志',
    },
    org: {
      deptName: '请输入部门名称',
    },
    excel: {
      import: '导入',
      importModel: '导入模版',
      readyData: '准备数据',
      downloadModule: '下载导入模版',
      downloadTips1: '所有允许导入的任务字段及规则请参考模板',
      downloadTips2: '字段不符合规则的，整个文件不予以导入',
      importData: '导入数据',
      updateFile: '上传文件',
      supportExtra: '支持扩展名',
      downloadName: '{name}模版',
    },
    bt: {
      reset: '重置',
      refresh: '刷新',
      Closeleft: '关闭左侧',
      Closeright: '关闭右侧',
      Closeothers: '关闭其他',
      Closerall: '关闭全部',
    },
    config: {
      configAll: '全部',
      levelHigh: '高风险',
      levelMedium: '中风险',
      levelLow: '低风险',
      levelNone: '免审批',
      levelDefault: '默认',
      typeView: '访问',
      typeFunction: '功能',
      typeData: '数据',
      statusNormal: '正常',
      statusInvalid: '失效',
      statusExpire: '即将过期',
      checkStatusInit: '进行中',
      checkStatusAllComplete: '已完成',
      checkStatusEndInit: '自动完成',
      checkStatusEndAllComplete: '已完成',
      statusAdd: '新增',
      statusModify: '修改',
      statusRemove: '逻辑删除',
      statusRemoveHard: '物理删除',
      statusSyncAdd: '同步新增',
      statusSyncUpdate: '同步更新',
      statusSyncDisable: '同步后失效',
      statusRecycleDisable: '回收失效',
      statusExpireDisable: '到期失效',
      statusAppDisable: '应用失效',
    },
    field: {
      affiliatedApp: 'appName',
      appName: 'name',
      ppName: 'name',
      ppDesc: 'desc',
      roleName: 'name',
      roleDesc: 'desc',
      ppRoleName: 'roleName',
      ppRoleDesc: 'roleDesc',
      associatedPpName: 'permissionName',
      menuName: 'name',
      relateName: 'relateName',
      userName: 'userName',
      managerName: 'name',
      departmentName: 'departmentName',
      ownerName: 'ownerName',
      ownerUserName: 'ownerUserName',
      sysName: 'sysName',
      taskName: 'taskName',
      periodName: 'name',
      descName: 'descName',
    },
    choose: {
      subordinate: '下级',
      userName: 'name',
      deptName: 'name',
      userDeptName: 'deptName',
      parentName: 'parentName',
      dept: '部门',
      user: '用户',
      menuName: 'name',
    },
    table: {
      number: '序号',
      affiliatedApp: '所属应用',
      affiliatedRole: '所属角色',
      affiliatedPoint: '所属权限点',
      menu: '关联菜单',
      ppIdentifier: '权限点标识',
      ppiName: '权限点标识/名称',
      authorizeName: '权限点名称',
      ppLevel: '权限点等级',
      ppType: '权限点类型',
      ppName: '权限点名称',
      ppNameEn: '权限点英文名称',
      ppDesc: '权限点描述',
      ppDescEn: '权限点英文描述',
      ppDescTip: '权限点描述，不超过100字',
      ppDescTipEn: '权限点英文描述，不超过100字',
      ppManager: '权限点负责人',
      createPoint: '创建权限点',
      editPoint: '修改权限点',
      operate: '操作',
      rolePermission: '角色权限',
      permissionPoint: '权限点',
      roleName: '角色名称',
      roleNameEn: '角色英文名称',
      roleManager: '角色负责人',
      roleIdentifier: '角色标识',
      roleDesc: '角色描述',
      roleDescEn: '角色英文描述',
      roleDescTip: '角色描述，不超过100字',
      roleDescTipEn: '角色英文描述，不超过100字',
      role: '角色',
      status: '状态',
      remainTime: '剩余时间',
      disableTime: '失效时间',
      grantTime: '授予时间',
      employeeName: '人员名称',
      personal: '人员',
      associatedPp: '关联权限点',
      associatedPpAdd: '添加关联权限点',
      subOnly: '只看直属下级',
      yes: '是',
      no: '否',
      sureRemoveRole: '你确定要移除该角色吗?',
      createRole: '创建角色',
      editRole: '编辑角色',
      isApply: '是否可申请',
      isEffective: '是否生效',
      isManagerControl: '主管是否可回收',
      permissionValidity: '权限有效期',
      roleValidity: '角色有效期',
      editMulti: '批量修改有效期',
      editPeriod: '修改有效期',
      validity: '有效期',
      userName: '用户姓名',
      userAccount: '用户账户',
      userAdd: '添加用户',
      defaultAuth: '默认授权人员',
      defaultAuthDept: '默认授权部门',
      regularEmployee: '内部员工',
      uutsourcedEmployee: '外包员工',
      externalUuser: '外部用户',
      overseasUser: '海外用户',
      selectDept: '选择部门',
      revokePermissionTip: '确定回收权限吗？',
      userQuery: '用户姓名、手机号、账号',
      removeRoleTip: '你确定要移除该角色吗？',
      disassociationTip: '确定取消关联吗？',
      selected: '已选',
      pleaseSearch: '请搜索',
      employee: '员工',
      department: '部门',
      revokeDisableTip: '该权限点暂未接入自动回收，请联系系统负责人回收对应权限',
      requiredMes: '该项为必填或必选项',
      periodTo: '至',
      lowerFileName: '下属权限.xlsx',
      ppUsersFileName: '权限点授权用户.xlsx',
      days: '天',
      checkStatus: '审阅结果',
      createTime: '审查周期',
      completeTime: '报告生成时间',
      taskStepOne: '审查权限',
      taskStepTwo: '回收权限(若需要)',
      taskStepThree: '提交审查结果',
      taskTitle: '权限审查',
      taskDeadline: '截止时间',
      taskDesc: '任务描述',
      taskDesc1_1: '1.请在到达完成期限之前，完成下属的权限审查工作，你需要分别审查',
      taskDesc1_2: '角色权限、权限点',
      taskDesc1_3: '分配的合理性，如发现不应授予的权限，请立即回收。',
      taskDesc2:
        '2.我们将在任务完成后向你发送权限审查报告；若未完成任务，系统将到期自动完成，审查报告结果默认为未审查。审查结果将上报CFO。',
      taskSubmit: '提交审查结果',
      taskHistory: '历史审查记录',
      reviewResult: '审阅结果',
      roleReviewResult: '角色权限审阅结果',
      permissionPointReviewResult: '权限点审阅结果',
      taskSubmitConfirm: '确定提交审查结果吗',
      referenceMaterial: '参考资料',
      taskCompleteTime: '任务完成时间',
      taskReportTime: '报告生成时间',
      taskStatus: '任务状态',
      reportFileName: '审查报告',
      statusUnnecessary: '已审查无需回收',
      statusUnreviewed: '未审查',
      statusDisable: '已审查已回收',
      reviewer: '审核人',
      reportPointTips: '仅显示中高风险权限点审查结果',
      accountName: '域账号',
      rolePointId: '角色/权限标识',
      roleId: '角色标识',
      pointId: '权限点标识',
      rolePointName: '角色/权限名称',
      pointName: '权限名称',
      operateTime: '操作时间',
      operateUser: '操作人',
      dataRange: '数据范围',
      dataRangeString: '数据范围',
      extra: '自定义字段',
      operationLog: '操作日志',
      viewLog: '查看日志',
    },
    btn: {
      reset: '重置',
      loadMore: '加载更多',
      selectUser: '选择用户',
      import: '导入',
      export: '导出',
      roleEdit: '成员组&权限',
      info: '详情',
      locked: '已锁定',
      add: '新增',
      submit: '提交',
      addChild: '添加子级',
      edit: '修改',
      authorize: '授权',
      del: '删除',
      cancel: '取消',
      sure: '确定',
      show: '查看',
      search: '搜索',
      advanceSearch: '高级筛选',
      sync: '同步',
      save: '保存',
      sureDel: '您确定要删除吗?',
      svaeC: '保存并继续',
      setRight: '配置权限',
      ppRelate: '关联权限点',
      revoke: '回收权限',
      revokePermissionTip: '确定回收权限吗？ ',
      editPeriod: '修改有效期',
      removeRole: '移除角色',
      disassociation: '取消关联',
      apply: '申请权限',
      collapse: '收起',
      detail: '详情',
      preview: '查看',
      download: '下载',
      previewFile: '查看附件',
      renewal: '续期',
    },
    mes: {
      noCurAndChild: '所选部门不能是当前部门或下级部门',
      delSuc: '删除成功',
      addSuc: '新增成功',
      addFail: '新增失败',
      editSuc: '修改成功',
      editFail: '修改失败',
      delerr: '删除失败',
      comSys: '通用系统',
      sureDel: '您确定要删除吗',
      isDelSelData: '确定要删除选中的数据吗？',
      syncSys: '请选择要同步的系统！',
      atLeastOne: '请选择一条数据进行删除',
      atLeastEdit: '请至少选择一条数据进行编辑',
      swlMoreMenu: '请确定要删除多个菜单吗？',
      permissonRevokeTip: '权限回收成功',
      roleRevokeTip: '角色权限回收成功',
      selectPersonDept: '请先选择人员或部门',
      selectPerson: '请先选择用户',
      periodSuccess: '权限有效期修改成功',
      userSuccess: '用户添加成功',
      selectPp: '请先选择权限点',
      associationSuccess: '权限点关联成功',
      disassociationSuccess: '权限点取消关联成功',
      pointDeleteTip: '该权限点已关联用户，权限点删除后不可恢复，你确定要删除权限点吗？',
      pointDeleteSecondTip: '即将删除该权限点，确认后将删除权限点',
      pointDeleteConfirm: '权限点删除确认',
      roleDeleteTip: '该角色已关联用户，删除后不可恢复，你确定要删除该角色吗？',
      roleDeleteSecondTip: '即将删除该角色，确认后将删除角色',
      roleDeleteConfirm: '角色删除确认',
      taskSuccessTitle: '审查任务已完成',
      taskSuccessContent1:
        '本次权限审查报告已生成，可直接查看，也可后续在「下属权限- 历史审查记录」中查看。',
      taskSuccessContent2: '日常工作也要管理下属权限，养成良好习惯，保障企业信息安全。',
      taskSuccessConfirm: '我知道了',
      taskSuccessCancel: '查看报告',
      querySelectAtLeast: '至少选择一个所属应用或人员',
      noTaskDetail: '暂无任务详情',
      selectApp: '请选择所属应用',
      selectAppAndRole: "请先选择前置条件"
    },
    user: {
      userRetainAD: '内部用户保留企业微信和ad',
      noSyncSF: '离职不同步sf',
      sn: '序号',
      peo: '人员',
      operation: '操作',
      inside: '内部',
      outside: '外部',
      loginStatus: '登录状态',
      inputSearch: '输入搜索部门',
      userStatus: '用户状态',
      userStatusSel: '请选择状态',
      user: '用户',
      userHold: '请输入姓名/账号/手机号',
      createS: '生成密钥',
      sureResetPas: '您确定要重置密码么',
      pasReset: '密码重置',
      sureStart: '确定启用？',
      start: '启用',
      sureForb: '确定禁用？',
      syncPeo: '人员同步',
      syncDate: '同步日期',
      account: '账号',
      accountInput: '请输入账号',
      mailPre: '邮箱前缀',
      name: '姓名',
      nameInput: '请输入姓名',
      chName: '中文名',
      dept: '所属部门',
      deptName: '部门名称',
      pos: '岗位',
      location: '工作地点',
      mobile: '手机号',
      mobileInput: '请输入手机号',
      max11: '最长支持11位',
      onlyNum: '只能输入数字',
      email: '邮箱',
      emailInput: '请输入邮箱',
      desc: '备注',
      descInput: '请输入备注',
      timeRange: '生效日期',
      role: '角色',
      userType: '用户类型',
      roleInput: '输入关键字模糊查询',
      normal: '正常',
      forb: '禁用',
      pleaseSelDept: '请选择部门',
      sCreSus: '生成密钥成功，请查收邮件',
      pasResetSus: '密码重置成功',
      addPeople: '新增用户',
      editPeople: '修改用户',
    },
    addExtra: {
      department: '部门',
      buildDepartment: '新建部门',
      search: '查询',
      reset: '重置',
      using: '启用中',
      deleted: '已删除',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      mainTable: {
        departmentName: '部门名称',
        buildTime: '创建时间',
        builder: '创建人',
        updateTime: '更新时间',
        updater: '更新人',
        operation: '操作',
      },
      deleteTable: {
        departemntName: '部门名称',
        buildTime: '创建时间',
        builder: '创建人',
        deleteTime: '禁用日期',
        deleter: '禁用人',
      },
      deleteSuccess: '删除成功',
      deleteError: '删除失败',
      departmentConfig: '部门信息',
      departmentEdit: '编辑部门',
      departmentAdd: '新增部门',
      addModal: {
        departmentName: '部门名称',
        inputDepartmentName: '输入部门名称',
        departmentNameEn: '部门名称(EN)',
        inputeDepartmentNameEn: '输入部门英文名称',
        departentCharger: '部门负责人',
        inputCharger: '请输入部门负责人',
        upperDepartment: '上级部门',
        cancel: '取消',
        confirm: '确定',
      },
      editModal: {
        pleaseInputDepartmentName: '请输入部门名称',
        departmentCode: '部门编码',
        departmentName: '部门名称',
        inputDepartmentName: '输入部门名称',
        departmentNameEn: '部门名称(EN)',
        inputeDepartmentNameEn: '输入部门英文名称(EN)',
        departmentCharger: '部门负责人',
        inputDepartmentCharger: '请输入部门负责人',
        upperDepartment: '上级部门',
        selectUpperDepartment: '请选择上级部门',
        del: '删除',
        buildTime: '创建时间',
        builder: '创建人',
        modifyTime: '最近修改时间',
        modifyer: '最近修改人',
        cancel: '取消',
        comfirm: '确定',
      },
      detailModal: {
        departmentCode: '部门编码',
        departmentName: '部门名称',
        departmentNameEn: '部门名称(EN)',
        upperDepartment: '上级部门',
        upperCharger: '部门负责人',
        costCenterCode: '成本中心编码',
        HRBP: 'HRBP',
        businessBP: '业财BP',
        resourceManager: '资产管理员',
        buildTime: '创建时间',
        builder: '创建人',
        modifyTime: '最近修改时间',
        modifyer: '最近修改人',
      },
      changeLog: {
        source: '来源',
        time: '时间',
        operateByPerson: '人为操作',
        all: '全部',
        timingTask: '定时任务更新',
        engin: '流程引擎',
        messageQueue: '消息队列处理',
        search: '查询',
        table: {
          operateTime: '操作时间',
          modal: '模块',
          name: '名称',
          source: '来源',
          modifyType: '修改类型',
          modifyfield: '修改字段',
          modifyBeforeContent: '修改前内容',
          modifyAfterContent: '修改后内容',
        },
      },
    },
    menu: {
      modal: {
        add: '新增菜单',
        edit: '编辑菜单',
      },
    },
    apply: {
      system: '申请应用',
      content: '申请理由',
      period: '申请有效期',
      addPoint: '添加权限点',
      addRole: '添加角色',
      submit: '提交申请',
      submitTip: '您确定提交吗？',
      deleteTip: '您确定删除吗？',
      selectPoint: '选择权限点',
      selectRole: '选择角色',
      selectSystem: '选择系统',
      roleManager: '角色负责人',
      name: '系统名称',
      nameEn: '系统英文名',
      serviceName: '服务名称',
      description: '系统描述',
      managerName: '系统负责人',
      submitSuccess: '申请提交成功',
      maxLength: '最多输入500字',
      selectSystemFirst: '请先选择应用!',
      changeSystemTip: '更换系统将会清空已选角色和权限点，确定要去更换吗？',
      otherTip: '当搜索不到想要的系统时请选其他，随后在申请理由中详述',
      submitPrevTip: '请至少选择一个角色或权限点!',
      seeMyPermission: '查看我的权限',
      moreQuestions: '若有更多疑问可查看',
      ITService: 'IT服务台',
      consult: '或咨询',
      applyTime: 'desc',
      successTipLeft: '您的权限申请已提交成功，请至',
      successTipCenter: '审批中心-我的申请',
      successTipRight: '查看审批进度',
      noData: '暂无数据',
      select: '选择',
      selectRolePoint: '选择申请角色/权限',
      selectDataRangeTip: '请选择数据范围',
      selectDataRange: '选择数据范围',
    },
  },
  productLine: {
    fix: {
      project: '项目',
      productName: '产品名称',
      productCode: '产品编码',
      belongToLine: '所属产品线',
      type: '类型',
      belongToChildLine: '所属子产品线',
      belongDept: '所属部门',
      productLeader: '产品负责人',
      pStartTime: '预计开始时间',
      pEndTime: '预计结束时间',
      sopTime: 'SOP时间',
      proDesc: '产品描述',
      projectName: '项目名称',
      projectCode: '项目编码',
      projectLeader: '项目负责人',
      projectDesc: '项目描述',
    },
    org: {
      code: '编码',
      childProLineLeader: '子产品线负责人',
      childProLinePdt: '子产品线主任',
      ipmtLeader: 'IPMT主任',
      productLineLeader: '产品线负责人',
      IPMTMembers: 'IPMT成员',
      proLineSearch: '产品线/子产品线/产品',
      input: '请输入',
      choose: '请选择',
      proLine: '产品线',
      proChildLine: '子产品线',
      product: '产品',
      proLineName: '产品线名称',
      departmentAffiliated: '所属部门',
      type: '业务线',
      startOrNot: '是否启用',
      proLineDesc: '产品线描述',
      visualRange: '可见范围',
      team1: '产品线团队',
      team2: '子产品线团队',
      team3: '产品团队',
      setting: '设置',
      proChildLineName: '子产品线名称',
      proLineAffiliated: '所属产品线',
      proChildLineDesc: '子产品线描述',
      productCode: '产品编码',
      planeStartTime: '预计开始时间',
      planeEndTime: '预计结束时间',
      SopTime: 'SOP时间',
      productDesc: '产品描述',
      addProLine: '新增产品线',
      editProLine: '编辑产品线',
      copyProLine: '复制产品线',
      addChildProLine: '新增子产品线',
      editChildProLine: '编辑子产品线',
      checkProduct: '查看产品',
      checkProject: '查看项目',
      expotrFile: '产品线.xlsx',
    },
    btn: {
      check: '查看',
      edit: '修改',
      copy: '复制',
      limit: '权限',
      del: '删除',
      cancel: '取消',
      submit: '提交',
      sure: '确定',
      show: '查看',
      search: '搜索',
      reset: '重置',
      sync: '同步',
      save: '保存',
    },
    mes: {
      comSys: '通用系统',
      sureDel: '您确定要删除吗',
      isDelSelData: '确定要删除选中的数据吗？',
      syncSys: '请选择要同步的系统！',
      atLeastOne: '请选择一条数据进行删除',
      atLeastEdit: '请至少选择一条数据进行编辑',
      copyConfirmTitle1: '将会复制',
      copyConfirmTitle2:
        '产品线信息、PDT团队和LMT团队成员至新的产品线中，请确认是否复制该产品线信息?',
    },
  },
  pages: {
    login: {
      ecarx: '主数据管理系统',
      title: '欢迎登录',
      bt: '登录',
      placeholder: {
        username: '请输入账号',
        password: '请输入密码',
      },
      code: '验证码',
      loginErr: '登录失败，请检查用户名和密码!',
      codeErr: '验证码输入错误',
    },
    sys: {
      btn: {
        addDict: '新增数据字典',
        editDict: '修改数据字典',
        showDict: '查看数据字典',
      },
      dict: {
        dataType: '数据字典类型',
        pHold1: '请输入编码或名称',
        pHoldCode: '请输入数据项编码',
        pHoldName: '请输入数据项名称',
        check1Mes: '请输入字母、数字和下划线',
        check2Mes: '最长支持15位',
        check3Mes: '最长支持25位',
        rule1: '请输入字母或数字',
        mes1: '数据项编码不可重复!',
        dataList: '数据项',
      },
      log: {
        name: '姓名',
        inputName: '请输入姓名',
        system: '系统',
        rolename: '角色名称',
        selectSys: '请选择系统',
        type: '类型',
        selectType: '请选择类型',
        outTime: '登出时间',
        inputLoginIp: '请输入登录IP',
      },
      config: {
        infoCode: '信息编码',
        inputInfoCode: '请输入信息编码',
        inputDesc: '请输入描述内容',
        zhDesc: '描述（简体中文）',
        enDesc: '描述（美式英文）',
      },
      table: {
        sn: '序号',
        code: '数据项编码',
        name: '数据项名称',
        lock: '锁定',
        typeCode: '数据字典类型编码',
        inputTypeCode: '请输入数据字典类型编码',
        inputTypeName: '请输入数据字典类型名称',
        typeName: '数据字典类型名称',
        createBy: '创建人',
        createTime: '创建时间',
        modifiedBy: '修改人',
        modifiedTime: '修改时间',
        optBtn: '操作',
        logSys: '登录系统',
        logIp: '登录IP',
        time: '时间',
        date: '日期',
        optUser: '操作人',
        optSys: '操作系统',
        optTime: '操作时间',
        selOptUser: '请输入操作人',
        optEve: '操作事件',
        selOptEve: '请输入操作事件',
        logStatus: '日志状态',
        params: '参数',
        selLogStatus: '请选择状态',
      },
    },
    user: {
      org: {
        pleaseAddUser: '请添加用户',
        lOrNum: '请输入字母或数字',
        max15: '最长支持15位',
        max25: '最长支持25位',
        deptCode: '部门编码',
        inputDeptCode: '请输入部门编码',
        deptName: '部门名称',
        inputDeptName: '请输入部门名称',
        supDept: '上级部门',
        inputSupDept: '请输入上级部门',
        lock: '锁定',
        createBy: '创建人',
        inputCreateBy: '请输入创建人',
        createTime: '创建时间',
        inputCreateTime: '请输入创建时间',
        modifyedBy: '修改人',
        inputModifyedBy: '请输入修改人',
        editTime: '修改时间',
        inputEditTime: '请输入修改时间',
        option: '操作',
      },
      sync: {
        syncAssets: '同步资产系统',
        syncABook: '同步通讯录',
        syncRole: '同步角色',
        syncContract: '同步合同系统',
        syncDept: '同步部门',
        syncPos: '同步岗位',
        syncPeople: '同步人员',
        cloudA: '同步云学堂',
        cloudApeople: '同步云学堂（人员）',
        cloudADept: '同步云学堂（部门）',
        costcenter: '成本中心',
        costcenterDesc: '同步成本中心（成本中心名称、成本中心编码、成本中心负责人）',
        costcenterDescDept: '组织架构',
        costcenterDescDeptDesc: '同步成本中心和组织架构关系',
        sfBtn: '同步SF',
        bcsBtn: '同步BCS',
        bcsDesc1: '同步成本中心',
        bcsDesc2: '同步组织架构关系',
        esbSys: 'ESB系统',
        syncEsb: '同步ESB',
        syncMk: '同步汇联易',
        syncWeWork: '同步企业微信',
        syncAd: '同步AD',
        weWork: '企业微信',
        sysOrg: '组织架构',
        syncLark: '同步飞书',
        issBt: '一键下发',
        umsIss: 'MDM下发数据',
        desc1: '全量同步7层组织架构、岗位、职能岗位、工作地点',
        desc2: '增量同步人员信息（新增、修改、离职）',
      },
      mes: {
        isSync: '确定同步？',
        isIss: '确定一键下发？',
      },
      table: {
        defaultRole: '全员默认角色',
        cata: '目录',
        menu: '菜单',
        btn: '按钮',
        sn: '序号',
        menuName: '菜单名称',
        menuNameEn: '菜单英文名称',
        menuNameInput: '请输入菜单名称',
        menuNameEnInput: '请输入菜单英文名称',
        name: '名称',
        accountName: '姓名',
        email: '域账号',
        mobile: '手机号',
        dept: '部门',
        icon: '图标',
        iconInput: '请输入图标名称',
        type: '类型',
        url: '地址',
        perm: '权限标识',
        sysName: '系统',
        roleName: '角色名称',
        roleNameIn: '请输入角色名称',
        sysType: '选择系统类型',
        description: '角色说明',
        descriptionIn: '请输入角色说明',
        member: '成员',
        memberSel: '选择成员',
        memberSelAxios: '输入成员昵称后进行模糊查询',
        right: '权限',
        addFormOrg: '通过内部组织架构添加',
        addFormWeb: '通过外部组织架构添加',
        leMenu: '上级菜单',
        menuType: '菜单类型',
        menuTypeSel: '请选择菜单类型',
        urlN: '链接地址',
        urlNInput: '请输入地址！',
        permsNInput: '请输入权限标识！',
        sort: '排序',
        sortInput: '请选择序号',
      },
    },
    vir: {
      roleTab: {
        resRole: '角色编码',
        code: '角色编码',
        name: '角色名称',
        teamIds: '所属团队',
        nameEn: '角色名称(EN)',
        roleDesc: '角色描述',
        teamName: '所属团队',
      },
      teamTab: {
        editRole: '编辑角色',
        addRole: '创建角色',
        cancel: '取消',
        save: '保存',
        roleConfig: '角色配置',
        teamBasicInfo: '团队基本信息',
        teamRoleConfig: '团队角色信息',
        createTeam: '创建团队',
        createRole: '创建角色',
        search: '搜索',
        reset: '重置',
        team: '团队',
        role: '角色',
        edit: '编辑',
        del: '删除',
        placeholderInput: '请输入',
        placeholderSelect: '请选择',
        sn: '序号',
        code: '团队编码',
        name: '团队名称',
        nameEn: '团队名称(EN)',
        teamDesc: '团队描述',
        createTime: '创建时间',
        createBy: '创建人',
        modifiedTime: '最近修改时间',
        modifiedBy: '最近修改人',
        enable: '状态',
        enable1: '启用',
        enable0: '禁用',
        type: '所属类型',
        parentCode: '上级团队',
        opt: '操作',
        mustMsg: '必填项',
        maxText20: '长度不超过20个字',
        maxText500: '长度不超过500个字',
      },
      bulkImport1: '批量导入内部用户',
      bulkImport2: '批量导入外部用户',
      bulkImport3: '批量导入内部组织',
      bulkImport4: '批量导入外部组织',
      hold1: '产品线/子产品线/产品/人员/项目',
      pLine: '产品线',
      cpLine: '子产品线',
      pro: '产品',
      project: '项目',
      editPeo: '增删成员',
      showMore: '查看更多',
      virManage: '虚拟组织维护',
      showTeamInfo: '查看团队详情',
      logout: '退出',
      tips: '提示',
      sureOut: '真的要注销登录吗 ?',
      signOut: '退出登录',
      refresh: '刷新',
      closeLeft: '关闭左侧',
      closeRight: '关闭右侧',
      closeOther: '关闭其它',
      closeAll: '关闭全部',
      professional: '专家组',
      professionalLeader: '专家组组长',
      proLineLeader: '产品线负责人',
      productLeader: '产品负责人',
      projectLeader: '项目负责人',
      login: {
        welcome: '欢迎登录MDM',
        account: '账号',
        password: '密码',
        code: '验证码',
        login: '登录',
        inputAc: '请输入账号',
        inputPs: '请输入密码',
        inputCode: '请输入验证码',
        slogan: '知识共享中心',
        userError: '用户名或者密码错误',
        langSwitch: '语言切换',
        langMessage: '当前语言:简体中文',
      },
    },
    cost: {
      totalNum: '(共{0}人)',
      costCenterName: '成本中心名称',
      costCentreCode: '成本中心编码',
      description: '成本中心描述',
      costCenterCode: '费用成本中心代码',
      fCostCenterName: '费用成本中心名称',
      salaryCostCenterCode: '薪资成本中心编码',
      salaryCostCenterName: '薪资成本中心名称',
      costCenterPla: '请输入成本中心名称/编码',
      costCenter: '成本中心',
      costCentreLeaderPla: '请输入成本中心负责人',
      companyCode: '公司编码',
      profitCenter: '利润中心',
      effectiveDate: '生效日期',
      disableDate: '失效日期',
      createTime: '创建日期',
      typeCN: '类型',
      modifiedTime: '修改日期',
      modifiedBy: '修改人',
      isDeleted: '是否删除',
      matchRelate: '匹配关系配置',
      search: '查询',
      searchPla: '请输入成本中心',
      reset: '重置',
      export: '导出',
      user: '用户',
      userPla: '姓名/手机号',
      status: '状态',
      name: '姓名',
      beToCostCentre: '所属成本中心',
      costCentreLeader: '成本中心负责人',
      contractSubject: '合同主体',
      beDept: '所属部门',
      lLeader: '直属上级',
      phone: '手机号',
      pos: '岗位',
      level: '岗级',
      commonPos: '常驻工作地',
      userStatus: '员工状态',
      userType: '员工类别',
      comSub: '费用公司',
      salarySub: '薪资公司',
      sureAndCon: '确定并继续',
      sure: '确定',
      cancel: '取消',
      selCom: '请选择合同主体',
      selSub: '请选择公司实体',
    },
    material: {
      textPld: '请输入',
      selectPld: '请选择',
      searchMPNPld: '制造商或MPN',
      searchPartPld: '料号或料名',
      material: '物料',
      close: '关闭',
      Category: '分类{count}',
      designer: '设计者',
      effective: '是否生效',
      designDate: '设计日期',
      invalidTime: '失效日期',
      validTime: '生效日期',
      versionResume: '版本履历',
      partId: '料号',
      unitName: '单位',
      chinaName: '料名',
      spec: '规格',
      description: '描述',
      source: '属性',
      typeName: '分类',
      manufacturer: '制造商',
      MPN: '制造商MPN',
      searchKeyHold: '物料编码或名称模糊搜索',
      search: {
        search: '搜索',
        reset: '重置',
        cancel: '取消',
      },
      partVar: '版本',
      sourceName: '属性',
      partStatus: '使用状态',
      kindName: '种类',
      workingTemperature: '工作温度',
      SMD: '湿敏等级',
      ESD: '静电防护ESD',
      partGrade: '物料等级',
      process: '制程',
    },
    feishu: {
      pla: {
        nameP: '请输入员工姓名',
        plaXin: '请输入姓拼音，不区分大小写',
        plaName: '请输入名拼音，不区分大小写',
        plaFull: '请输入姓名拼音，不区分大小写',
        input: '请输入',
        select: '请选择',
        inputAppName: '请输入产品名称',
      },
      employeeInfo: '员工信息',
      accountInfo: '账号信息',
      basicInfoSF: '基本信息(sf)',
      basicInfoFS: '基本信息(飞书人事)',
      basicInfoExtra: '基本信息(外部用户)',
      perInfo: '个人信息',
      name: '姓名',
      nameEn: '姓名(EN)',
      xingPinyin: '姓(拼音)',
      mingPinyin: '名(拼音)',
      namePinyin: '姓名(拼音)',
      mobile: '手机号',
      gender: '性别',
      idNumber: '证件号',
      userInfo: '用户信息',
      account: '账号',
      entryDate: '入职日期',
      userType: '人员类型',
      dockingPeople: '亿咖通对接人',
      post: '岗位',
      workPlace: '工作地',
      belongDept: '所属组织',
      postLevel: '岗级',
      immediateSuperior: '直属上级',
      validateDate: '有效期',
      remark: '备注',
      enabled: '启用',
      disabled: '禁用',
      isSure: '确认操作？',
      user: '用户',
      userHold: '用户名/账号/手机号',
      sn: '序号',
      userName: '用户名',
      email: '联系邮箱',
      tags: 'tags',
      createDate: '创建时间',
      modifyDate: '最近修改时间',
      modifyBy: '最近修改人',
      operator: '操作',
      cancel: '取消',
      save: '保存',
      btn: {
        createUser: '新建外部用户',
        createDept: '新建部门',
        hasStop: '已停用',
        search: '查询',
        reset: '重置',
        stop: '停用',
      },
      onJob: '在职',
      offJob: '离职',
      userId: '用户id',
      departmentNamePath: '所属部门',
      userStatus: '人员状态',
      userTypeText: '人员类型',
      edit: '编辑',
      workNum: '工号',
      Assistant: '助理',
      clickEdit: '点击可编辑',
      emailError: '请输入正确的邮箱!',
      mainUser: '负责人',
      openApp: '开通应用',
      openAppPer: '开通应用权限',
      appName: '产品名称',
      validateRange: '账号权限有效期',
      appPerm: '应用权限',
      accountStatus: '账号状态',
      openTime: '开通时间',
      openBy: '开通人',
      loginDate: '最后登录时间',
      delApp: '解除开通',
      male: '男',
      female: '女',
      Supplier: '供应商',
      Partners: '合作伙伴',
      addUser: '添加员工',
      correctEmail: '请输入正确的邮箱',
      show: '显示',
      idCards: {
        cardType1: '+身份证',
        cardType2: '+港澳通行证',
        cardType3: '+台湾居民来大陆通行证',
        cardType4: '+护照',
        cardType5: '+其它',
      },
      accountStatuses: {
        status1: '正常',
        status2: '改密冻结',
        status3: '校验冻结',
        status4: '禁用',
        status5: '信息待补全',
      },
      isSureUnbind: '确认解除开通？',
      table: {
        deptName: '部门名称',
        createDate: '创建时间',
        createPelple: '创建人',
        updateDate: '更新时间',
        updatePelple: '更新人',
        option: '操作',
        optTime: '操作时间',
        dataType: '模块',
        userName: '名称',
        changeSource: '来源',
        type: '修改类型',
        theme: '修改字段',
        oldContent: '修改前内容',
        newContent: '修改后内容',
        enableDatetime: '生效日期',
        disableDatetime: '失效日期',
      },
      all: '全部',
      allData: '全部信息',
      changeLog: '变更记录',
      changeSource: '来源',
      nameInfo: '请输入名称',
      dataType: '数据类型',
      dataTypes: {
        type1: '员工数据',
        type2: '部门数据',
        type3: '帐户数据',
        type4: '用户数据',
        type5: '帐号开通应用',
        type6: '帐号关联数据',
        type7: '用户成本中心',
        type8: '部门关联数据',
        type9: '部门管理人员数据',
        type10: '临时用户数据',
        type11: '外包数据',
        type12: '帐号关联外部ID',
      },
      sources: {
        type1: '人为操作',
        type2: '定时任务更新',
        type3: '流程引擎',
        type4: '消息队列处理',
      },
      editTypes: {
        type1: '新增',
        type2: '修改',
        type3: '逻辑删除',
        type4: '物理删除',
      },
      noEmptyData: '数据项不能为空',
      createUser: '创建用户',
      createAccount: '创建帐号',
      openPerm: '开通权限',
      continueCA: '继续创建账号',
      previewStep: '上一步',
      pDeptSel: '请选择所属组织',
      pUserSel: '请输入对接人',
      onlyLetter: '请输入字母',
      spellError: '姓名拼音输入错误',
      noSpecText: '不能输入特殊字符',
      onlyNumber: '请输入数字',
    },
    appManage: {
      sn: '序号',
      name: '应用名称',
      enName: '应用名称(EN)',
      appUrl: '应用地址',
      appDesc: '应用描述',
      Administrator: '管理员',
      status: '应用状态',
      visibleRange: '可见范围',
      availablePeople: '可用人员id',
      availableDept: '可用部门id',
      operator: '操作',
      createApp: '创建应用',
      pla: {
        must: '必填项',
        name: '请输入应用名称/管理员',
        appName: '请填写应用名称',
        enName: '请填写应用英文',
        url: '请填写应用地址',
        desc: '请填写应用描述',
        admin: '添加管理员',
        adminId: '输入人员id，以英文逗号分隔',
        deptId: '输入部门id，以英文逗号分隔',
      },
      appStatuses: {
        status1: '开发中',
        status2: '运行中',
        status3: '已下线',
      },
      edit: '编辑',
      cancel: '取消',
      save: '保存',
      basicInfo: '基本信息',
      roleManage: '角色管理',
      clickEdit: '点击可编辑',
      noEmptyData: '数据项不能为空',
      copySuccess: '复制成功',
      copy: '复制',
      copyFail: '复制失败',
    },
  },
  app: {
    lang: {
      langSwitch: '语言切换',
      langMessage: '当前语言:简体中文',
    },
    account: {
      center: '个人中心',
      help: '帮助中心',
      settings: '个人设置',
      logout: '退出登录',
      lang: '语言切换',
      dialog: {
        title: '提示',
        content: '您确定要注销登录吗？',
      },
    },
  },
  feedback: {
    feedback1: '反馈一下',
    satisfied: 'Hi，你对这个系统的使用满意吗?',
    complaints: '欢迎任何吐槽、建议等',
    send: '发送',
    thanks: '感谢您的反馈！',
    nice: 'Hi，很高兴遇见你，有问题可以在这里反馈哦！',
    upload: '上传图片',
    anOther: '再来一条',
    close: '后自动关闭',
    help: '帮助文档',
    it: 'IT服务台',
    vbad: '非常不好',
    notgood: '不大好',
    justsoso: '一般',
    Nice: '还行',
    Excellent: '非常好',
  },
  'authority:my:view': '我的权限',
  'authority:view': '人员权限',
  'authority:point:view': '权限点管理',
  'authority:role:view': '角色管理',
  'authority:subordinate:view': '下属权限',
  'authority:menu:view': '菜单管理',
  'authority:report:view': '审查报告',
  'authority:group:report': '公司审查报告',
  'authority:task:report': '人员审查报告',
  'authority:log:view': '权限日志',
  'log:rolePoint:view': '角色/权限日志',
  'log:person:view': '人员日志',
};
